const CACHE_PREFIX = 'time2lucky:rtdb-cache:v1:'
const DEFAULT_TTL_MS = 2 * 60 * 1000
const memoryCache = {}
const inFlightLoads = {}

function storage () {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null
  } catch (error) {
    return null
  }
}

function readStoredValue (cacheKey, now) {
  const target = storage()
  if (!target) return null

  try {
    const raw = target.getItem(`${CACHE_PREFIX}${cacheKey}`)
    if (!raw) return null
    const entry = JSON.parse(raw)
    if (!entry || entry.expiresAt <= now) {
      target.removeItem(`${CACHE_PREFIX}${cacheKey}`)
      return null
    }
    return entry
  } catch (error) {
    return null
  }
}

function storeValue (cacheKey, entry) {
  const target = storage()
  if (!target) return

  try {
    target.setItem(`${CACHE_PREFIX}${cacheKey}`, JSON.stringify(entry))
  } catch (error) {
    // Storage can be unavailable or full; the in-memory cache still works.
  }
}

export function getSessionCachedData (cacheKey, loader, ttlMs = DEFAULT_TTL_MS) {
  const now = Date.now()
  const memoryEntry = memoryCache[cacheKey]
  if (memoryEntry && memoryEntry.expiresAt > now) {
    return Promise.resolve(memoryEntry.value)
  }

  const storedEntry = readStoredValue(cacheKey, now)
  if (storedEntry) {
    memoryCache[cacheKey] = storedEntry
    return Promise.resolve(storedEntry.value)
  }

  if (inFlightLoads[cacheKey]) return inFlightLoads[cacheKey]

  const load = Promise.resolve().then(loader).then(value => {
    const entry = {
      value,
      expiresAt: Date.now() + ttlMs
    }
    memoryCache[cacheKey] = entry
    storeValue(cacheKey, entry)
    delete inFlightLoads[cacheKey]
    return value
  }).catch(error => {
    delete inFlightLoads[cacheKey]
    throw error
  })

  inFlightLoads[cacheKey] = load
  return load
}
